module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-05.ad9a7020.png";